import { render, staticRenderFns } from "./ByRegion.vue?vue&type=template&id=5c52aa4c&scoped=true"
import script from "./ByRegion.vue?vue&type=script&lang=js"
export * from "./ByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52aa4c",
  null
  
)

export default component.exports